{
  "0420c8cfb9f4056f": "Ingrese la cantidad de horas",
  "0a5d5c335cd87d5f": "Gasto total",
  "0ebb39cc4c16c273": "Gasto Total Restante",
  "0efff1043328c356": "Gasto Total Estimado",
  "0faaef05c2ec697d": "Editar Límite de Aumento de Tarifas",
  "11924d5b6061804d": "Solicitando un aumento al límite de incremento semanal.",
  "19766ed6ccb2f4a3": "Cancelar",
  "1ce8564993cc9ca4": "Editar Límite de Gasto",
  "21fbde19cfb095cd": "La próxima semana",
  "2d99e344a37673d9": "¿Cuántas horas adicionales se necesitan para esta semana más allá de los turnos ya publicados?",
  "36070f2eaf96bd11": "Horas adicionales",
  "377ad93554b126f9": "Total de Horas Estimadas",
  "3845725f02579dbd": "Establecer Límite de Gasto",
  "38593914ba8b6bb5": "Habilitar límite semanal",
  "4132287e112040eb": "Límite semanal actual: {{limit}}",
  "47d2a515ef2f05b8": "Cargando...",
  "4e9682fa850ed767": "hrs",
  "562361f9ac5ecfd1": "Rastrear su gasto semanal",
  "6a2769502a5dda78": "Mes anterior",
  "74cc8f1e7caf6b69": "Gasto restante total",
  "74e53211fef4b4d4": "Próximo mes",
  "76900f1bfd16c8d4": "Atrás",
  "7d52938e8dfb7183": "Aumentos de tarifa",
  "7fb24165588aaad2": "Error al cargar los controles de gasto. Por favor, inténtalo de nuevo.",
  "813ede96a15c4c82": "Ingresa un valor...",
  "8648fae145505743": "Aumento de límite solicitado",
  "8976f7983aefb33d": "Horas adicionales necesarias",
  "8a5fb7689fb2ff13": "Establecer Límite de Aumento de Tarifas",
  "8c8900658a4c983f": "fields[workplace]=name",
  "920c2e9272d7c60d": "Aplicar a todas las semanas próximas",
  "93483c938871b25a": "Límite semanal",
  "9a03073fb5cf415d": "Controles de gasto",
  "a26984e36fa0880a": "Gasto adicional semanal (USD)",
  "a68319de5050274b": "Horas totales estimadas",
  "ad96512f119ff9c4": "Solicitud de aumento de gasto enviada.",
  "c0f8bbcd417656cf": "Semana anterior",
  "c1b24f6b30395848": "Solicitar aumento de límite",
  "dc85af8f2b1d0d67": "Guardando...",
  "e013d99a98ac54d0": "Solicitar aprobación",
  "e0ab581aca1cd51a": "Total de Horas Restantes",
  "e33a24e7fd82e2cf": "Ver y gestionar el gasto para sus lugares de trabajo",
  "e5f88d676e85885b": "Horas restantes totales",
  "eebdd24a77d9ad32": "Confirmar",
  "efe7287d10ef5fe2": "Solicitar Aumento",
  "f226b929723805ed": "Ingrese la cantidad en dólares",
  "f6b545e21025ec1e": "Gasto total estimado",
  "f7d718d88896690a": "Crear este turno excede el límite de gasto semanal establecido para su lugar de trabajo. ¿Cuántas horas adicionales se necesitan para la semana?",
  "fc5236e6362fb5f6": "Límite de gasto alcanzado para la semana del turno"
}
